import React, { useState, useEffect } from "react";
import { get, put } from "../../services/Services";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUserCheck, FaTimes } from "react-icons/fa";

const AddRepresentative = ({ schoolId, onClose, onAddUser }) => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await get("/api/core/users?page=0&size=100");
        if (response.data.content && response.data.content.length > 0) {
          setUsers(response.data.content);
        } else {
          alert("No se han encontrado usuarios.");
        }
      } catch (err) {
        console.error("Error al cargar usuarios:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedUserId) {
      alert("Por favor, selecciona un usuario.");
      return;
    }

    setSubmitting(true);

    try {
      await put(`/api/academy/schools/${schoolId}/user`, {
        userId: parseInt(selectedUserId),
      });

      onAddUser?.(); // Actualiza vista padre
      onClose();     // Cierra modal
    } catch (err) {
      console.error("Error al agregar representante:", err);
      alert("Hubo un problema al asignar el representante.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <p>Cargando usuarios...</p>;
  if (error) return <p>Error al cargar usuarios: {error.message}</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Agregar Representante</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label htmlFor="user" className="form-label fw-semibold">
                Selecciona un usuario:
              </label>
              <select
                id="user"
                className="form-select"
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value)}
              >
                <option value="">Selecciona un usuario</option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.userData?.name} {user.userData?.lastname}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex justify-content-between gap-2">
              <button
                type="submit"
                className="btn btn-primary w-50 d-flex align-items-center justify-content-center gap-2"
                disabled={submitting}
              >
                <FaUserCheck />
                {submitting ? "Asignando..." : "Asignar"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary w-50 d-flex align-items-center justify-content-center gap-2"
                onClick={onClose}
              >
                <FaTimes />
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRepresentative;
